import { IStorage } from "namirasoft-core";
import { NamirasoftAccountHeader } from "./NamirasoftAccountHeader";
import { NamirasoftAccountToken } from "./NamirasoftAccountToken";
import { SessionRow } from "./row/SessionRow";
import { UserRow } from "./row/UserRow";

export class TokenManager
{
    storage: IStorage;
    onUserChanged: () => void;
    constructor(storage: IStorage, onUserChanged: () => void)
    {
        this.storage = storage;
        this.onUserChanged = onUserChanged;
        this.getText = this.getText.bind(this);
        this.setText = this.setText.bind(this);
        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
        this.del = this.del.bind(this);
        this.exists = this.exists.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setUser = this.setUser.bind(this);
        this.getValue = this.getValue.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.getSessionData = this.getSessionData.bind(this);
    }
    getText()
    {
        let name: string = NamirasoftAccountHeader.req.TOKEN();
        return this.storage.get(name, "");
    }
    setText(text: string, isTheSameUser: boolean)
    {
        let name: string = NamirasoftAccountHeader.req.TOKEN();
        this.storage.set(name, text);
        if (!isTheSameUser)
            if (this.onUserChanged)
                this.onUserChanged();
    }
    set(token: NamirasoftAccountToken, isTheSameUser: boolean): void
    {
        this.setText(JSON.stringify(token), isTheSameUser);
    }
    get(): NamirasoftAccountToken | null
    {
        let text = this.getText();
        if (text)
            return JSON.parse(text) as NamirasoftAccountToken;
        return null;
    }
    del()
    {
        let name: string = NamirasoftAccountHeader.req.TOKEN();
        this.storage.del(name);
    }
    exists(): boolean
    {
        let ans = this.get();
        if (ans?.value)
            return true;
        return false;
    }
    setValue(value: string, isTheSameUser: boolean)
    {
        let token = this.get();
        if (!token)
            token = { user: null, session: null, value };
        token.value = value;
        this.set(token, isTheSameUser);
    }
    setUser(user: UserRow | null)
    {
        let token: NamirasoftAccountToken | null = this.get();
        if (token)
        {
            token.user = user;
            this.set(token, false);
        }
    }
    getValue()
    {
        return this.get()?.value;
    }
    getUserData<D = any>(getter: (user: UserRow) => D, onNull: D): D
    {
        let token = this.get();
        if (token)
            if (token.user)
                return getter(token.user as UserRow);
        return onNull;
    }
    getSessionData<D = any>(getter: (user: SessionRow) => D, onNull: D): D
    {
        let token = this.get();
        if (token)
            if (token.session)
                return getter(token.session);
        return onNull;
    }
}